/*eslint-disable*/
import { useState, useMemo } from "react";
import { toast } from 'react-toastify'

// helpers
import { groupBy } from "../../helpers/general";

// services
import { fetchUsers } from '../../services/user';

const useLocalUsers = () => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const getUsers = async (filter) => {
        try {
          if(filter.includes('null')) return;
          setIsLoading(true)
          const response = await fetchUsers(filter)
          const allUsers = response?.data?.resources
          if (allUsers.length == 0) {
            toast.error('No matching records found, please modify your search and try again')
          }
          setUsers(allUsers)
          setIsLoading(false)
        } catch (error) {
          toast.error(error.message)
          setIsLoading(false)
        }
      }

    const usersById = useMemo(() => groupBy(users, 'id'), [users])

    return {users, areUsersLoading: isLoading, getUsers, usersById };
}

export default useLocalUsers;